import React, { useState, useEffect } from "react";
import { Table, Button, Form, InputGroup } from "react-bootstrap";
import { FaEdit, FaSave, FaTrash, FaPlus } from "react-icons/fa";
import { createCategory, getCategories, updateCategory, deleteCategory } from "../api";
const initialData = [
  { id: 1, label: "Xerox" },
  { id: 2, label: "Color Xerox" },
  { id: 3, label: "Print Out" },
  { id: 4, label: "Color Print Out" },

];

const CategoryTable = () => {
  const [categories, setCategories] = useState(initialData);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);

  const rowsPerPage = 10;

  const handleEdit = (id, label) => {
    setEditId(id);
    setEditName(label);
  };

  const handleSave = (id) => {
    const updated = categories.map((cat) =>
      cat.id === id ? { ...cat, label: editName } : cat
    );
    setCategories(updated);
    setEditId(null);
    updateCategory(id, updated.filter((category) => category.id === id)[0])
      .then(() => {
        alert('Category updated successfully');
        console.log("Category updated successfully");
      })
      .catch((error) => {
        alert('Error updating Category');
        console.error("Error updating Category:", error);
      });
  };

  const handleDelete = (id) => {
    const updated = categories.filter((cat) => cat.id !== id);
    setCategories(updated);
    deleteCategory(id)
      .then(() => {
        alert("Category deleted successfully");
        console.log("Category deleted successfully");
      })
      .catch((error) => {
        alert("Error deleting category");
        console.error("Error deleting category:", error);
      });
  };

  const handleAdd = () => {
    const newId = categories.length ? Math.max(...categories.map(c => c.id)) + 1 : 1;
    setCategories([{ id: newId, label: "" }, ...categories]);
    setEditId(newId);
    setEditName("");
    const newCat = [{ id: newId, label: "" }];
    createCategory(newCat)
      .then(() => {
        // alert("Category added successfully");
        console.log("Category added successfully");
      })
      .catch((error) => {
        alert("Error adding category");
        console.error("Error adding category:", error);
      });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(e.target.value.toLowerCase());
    setPage(0); // reset to first page on new search
  };

  const filtered = categories.filter(cat => cat.label.toLowerCase().includes(search));
  const totalPages = Math.ceil(filtered.length / rowsPerPage);
  const displayed = filtered.slice(page * rowsPerPage, (page + 1) * rowsPerPage);


  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getCategories()
      .then((res) => {
        console.log(res.data);
        setCategories(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching categories:', err);
        setLoading(false);
      });
  }, []);
  if (loading) return <p>Loading...</p>;

  return (
    <div className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Category Table</h3>
        <Button variant="success" onClick={handleAdd}>
          <FaPlus /> Add Row
        </Button>
      </div>

      <InputGroup className="mb-3">
        <InputGroup.Text>Search</InputGroup.Text>
        <Form.Control
          type="text"
          placeholder="Search category..."
          value={search}
          onChange={handleSearch}
        />
      </InputGroup>

      <Table striped bordered hover responsive>
        <thead className="table-light">
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th style={{ width: "120px" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {displayed.map((cat) => (
            <tr key={cat.id}>
              <td>{cat.id}</td>
              <td>
                {editId === cat.id ? (
                  <input
                    type="text"
                    className="form-control"
                    value={editName}
                    onChange={(e) => setEditName(e.target.value)}
                  />
                ) : (
                  cat.label
                )}
              </td>
              <td className="text-center">
                {editId === cat.id ? (
                  <Button variant="primary" size="sm" onClick={() => handleSave(cat.id)}>
                    <FaSave />
                  </Button>
                ) : (
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => handleEdit(cat.id, cat.label)}
                  >{" "}
                    <FaEdit />
                  </Button>
                )}{" "}
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => handleDelete(cat.id)}
                >
                  <FaTrash />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <div className="d-flex justify-content-between align-items-center mt-3">
        <div>
          Showing {page * rowsPerPage + 1} -{" "}
          {Math.min((page + 1) * rowsPerPage, filtered.length)} of {filtered.length}
        </div>
        <div>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
            disabled={page === 0}
          >
            Prev
          </Button>{" "}
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => setPage((prev) => Math.min(prev + 1, totalPages - 1))}
            disabled={page >= totalPages - 1}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CategoryTable;
